import { HYDRATE } from "next-redux-wrapper";
import { ActionsMyOrders } from "./actions";

const initialState = { data: {}, status: "fetch_init", message: "" };

function storeMyOrders(state = initialState, action) {

	switch (action.type) {

	case HYDRATE: {

		return { ...state, ...action.payload.storeMyOrders };

	}
	case ActionsMyOrders.LOAD_GET_MY_ORDERS:
		return { ...state, data: action.data, status: "fetch_loading" };
	case ActionsMyOrders.RES_GET_MY_ORDERS:
		return { ...state, data: action.data, status: "fetch_result" };
	case ActionsMyOrders.ERR_GET_MY_ORDERS:
		return {
			...state, data: {}, status: "fetch_error", message: "Error...",
		};
	default: {

		return {
			...state,
		};

	}

	}

}

export default storeMyOrders;
